var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { CopyIcon } from '../icon';
import { IconButton } from '../icon-button';
import { Tooltip } from '../tooltip';
export var CopyButton = React.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, iconButtonProps = __rest(_a, ["onClick"]);
    var _b = __read(React.useState(false), 2), pressed = _b[0], setPressed = _b[1];
    React.useEffect(function () {
        if (!pressed) {
            return undefined;
        }
        var timeout = setTimeout(function () {
            setPressed(false);
        }, 5000);
        return function () { return clearTimeout(timeout); };
    }, [pressed]);
    var handleClick = function (event) {
        if (onClick) {
            setPressed(true);
            onClick(event);
        }
    };
    var handleClose = function () { return setPressed(false); };
    // use title as the key to force a mount/unmount of the tooltip. This drives the feedback transition.
    var title = pressed ? 'Copied!' : 'Copy';
    return (React.createElement(Tooltip, { key: title, title: title, placement: "top", onClose: handleClose },
        React.createElement(IconButton, __assign({ ref: ref, onClick: handleClick }, iconButtonProps),
            React.createElement(CopyIcon, null))));
});
